export const CasterServiceBaseUrl = 'https://ieijla1gv5.execute-api.us-west-2.amazonaws.com/qa';
export const CasterSharedServiceBaseUrl = 'https://wsapi.qa.caster.warnerbros.com';
export const OKTA_CLIENT_ID = "0oa166ulm4wUx3Wpr0h8";
export const CasterServiceWSBaseUrl ='wss://gqng09k4ik.execute-api.us-west-2.amazonaws.com/qa'; 
export const OKTA_ISSUER_URL = "https://ssobizqa.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://ssobizqa.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";